require('../fhApp/currentUser/currentUser');
require('../mainFrame/collapsableMenu/collapsableMenuService');

"use strict";

angular.module('app.login.loginController', [
  'app.mainFrame.collapsableMenu.collapsableMenuService'
])
  .controller('app.login.loginController', [
    '$scope', 'currentUser', '$state', '$stateParams', 'app.mainFrame.collapsableMenu.collapsableMenuService',
    function ($scope, currentUser, $state, $stateParams, collapsableMenu) {
      $scope.error = $stateParams.error;
      $scope.errorType = $stateParams.errorType;
      $scope.login_name = $stateParams.login_name;
      $scope.password = null;
      $scope.email = null;
      $scope.showPassword = false;
      $scope.passwordType = 'password';

      let init = () => {
        if ($stateParams.autoLogin === true) {
          if ($stateParams.login_name && $stateParams.password) {
            $scope.password = $stateParams.password;
            $scope.login();
          }
        }
      };

      $scope.login = function () {
        currentUser.loginClicked = true;

        let callback = function () {
          collapsableMenu.buildItems();

          if ($stateParams.redirect) {
            $state.go($stateParams.redirect, $stateParams.redirectParams);
          }
          else if (typeof $state.current.goBack === 'function') {
            $state.current.goBack(true);
          }
          else {
            $state.go('app.home');
          }
        };

        currentUser.login($scope.login_name, $scope.password)
          .then(callback)
          .catch(result => {
            $state.go('app.login', result);
          });
      };

      $scope.resendRegistrationEmail = () => {
        if ($scope.login_name) {
          currentUser.sendRegistrationEmail($scope.login_name)
            .then(() => {
              alert("Your confirmation email has been re-sent");
            })
            .catch(response => {
              alert("There was an error sending the confirmation email. Please try again later.");
            });
        } else {
          alert("We are unable to re-send the confirmation email at this time. Please try again later.");
        }
      };

      $scope.showPasswordClick = () => {
        $scope.showPassword = !$scope.showPassword;
         if($scope.showPassword) {
           $scope.passwordType = "text";
         } else {
           $scope.passwordType = "password";
         }
      };

      init();
    }
  ]);



// WEBPACK FOOTER //
// ./app.v2/components/login/loginController.js